<template>
  <UikitDialog
    :model-value="modelValue"
    position="right"
    full-height
    :hide-close="!isDesktop"
    content-class="osk-filters-sizes-info-dialog"
    slide-right
    @update:model-value="emits('update:modelValue', $event)"
    @handle-close="handleClose"
  >
    <div class="osk-filters-sizes-info-dialog__wrapper">
      <div class="osk-filters-sizes-info-dialog__header">
        <UikitIcon
          name="ArrowBack"
          size="l"
          @click="emits('update:modelValue', false)"
        />

        <div
          class="osk-filters-sizes-info-dialog__refresh"
          @click="handleReset"
        >
          Сбросить всё
        </div>
      </div>

      <div class="osk-filters-sizes-info-dialog__content">
        <BusinessProductsFiltersSizesInfo
          v-model:selected-items="selected"
          :category-size="categorySize"
          is-catalog
          :page="page"
        />
      </div>

      <div class="osk-filters-sizes-info-dialog__footer">
        <UikitButton
          full-width
          :disabled="!itemsCount"
          :loading="loading"
          :size="isDesktop ? 'm' : 'l'"
          @click="handleApply"
        >
          Показать
          <template v-if="itemsCount">
            ({{ itemsCount }})
          </template>
        </UikitButton>
      </div>
    </div>
  </UikitDialog>
</template>

<script setup lang="ts">
import { CategorySize, ListValue } from '~/restAPI/data-contracts';

const props = defineProps<{
  modelValue: boolean,
  categorySize?: CategorySize
  selectedValues: ListValue[]
  itemsCount?: number
  loading?: boolean
  page?: string
}>();

const emits = defineEmits<{
  (e: 'update:modelValue', value: boolean): void,
  (e: 'updateFilter', value: ListValue[]): void,
  (e: 'closeAll'): void,
  (e: 'apply'): void,
}>();

const { isDesktop } = useUiBreakpoints();

const selected = ref<ListValue[]>();

function handleClose() {
  emits('closeAll');
}

function handleApply() {
  emits('update:modelValue', false);
  emits('apply');
}

function genSelected() {
  return props.selectedValues;
}

function handleReset() {
  selected.value = selected.value?.filter((item) => {
    const child = props.categorySize?.sizesValue.values?.find((value) => value.id === item.id);

    return !child;
  });
}

watch(selected, (list) => {
  if (list === undefined) return;

  emits('updateFilter', list);
}, { deep: true });

watch(() => props.modelValue, (value) => {
  if (value) {
    selected.value = genSelected();
  } else {
    selected.value = undefined;
  }
});
</script>

<style lang="scss">
@import "~/assets/scss/settings/index";

.osk-filters-sizes-info-dialog {
  padding-top: 0 !important;
  padding-left: 0 !important;
  padding-right: 0 !important;

  @include media-query(lg-and-up) {
    width: 504px !important;
  }

  .osk-dialog__close {
    right: 50px !important;
  }

  &__wrapper {
    display: flex;
    flex-direction: column;
    height: 100%;

    @include media-query(lg-and-up) {
      padding-top: 94px;
    }
  }

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    padding: 10px 16px;

    @include media-query(lg-and-up) {
      padding: 0 52px;
    }

    .osk-icon {
      cursor: pointer;
      margin-left: -6px;

      &:hover {
        opacity: .6;
      }
    }
  }

  &__refresh {
    color: $grey;
    cursor: pointer;

    @include media-query(lg-and-up) {
      margin-left: auto;

      &:hover {
        text-decoration: underline;
      }
    }
  }

  &__content {
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    height: 100%;
    padding: 12px 16px 0;
    position: relative;

    @include media-query(lg-and-up) {
      padding: 26px 52px 0;
    }
  }

  &__footer {
    padding: $indent-medium $indent-medium 0;

    @include media-query(lg-and-up) {
      padding: $indent-medium 52px 22px;
    }
  }
}
</style>
